import { Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaSimulationPerFormBuilder extends PrFormAbstract {
  options;

  generate(entity: any, options?: any) {
    this.options = options;

    return this.formBuilder.group({
      productId: [entity ? entity.productId : null, null],
      initialDeposit: [
        entity ? entity.initialDeposit : null,
        Validators.required,
      ],
      monthlyDeposit: [
        entity ? entity.monthlyDeposit : null,
        Validators.required,
      ],
      durationInYears: [
        entity ? entity.durationInYears : null,
        Validators.nullValidator,
      ],
      age: [entity ? entity.age : null, Validators.required],
      retirementAge: [
        entity && entity.retirementAge ? entity.retirementAge : 68,
        Validators.required,
      ],
      entryFee: [
        entity ? entity.entryFee * 100 : null,
        this.prFormService.AddValidatorsBasedOnCondition(
          () => options && options.sessionConsultant,
          Validators.required,
        ),
      ],
      plafond: [
        entity ? entity.plafond : null,
        Validators.nullValidator,
      ],
    });
  }

  extract() {
    let dto: any = {
      id: null,
      productId: this.emptyIsNull(this.form.value.productId),
      initialDeposit: this.emptyIsNull(this.form.value.initialDeposit),
      monthlyDeposit: this.emptyIsNull(this.form.value.monthlyDeposit),
      durationInYears: this.emptyIsNull(
        this.parseFloat(this.form.value.durationInYears),
      ),
      age: this.emptyIsNull(this.form.value.age),
      retirementAge: this.emptyIsNull(this.form.value.retirementAge),
      entryFee: this.emptyIsNull(this.form.value.entryFee / 100),
      plafond: this.emptyIsNull(this.form.value.plafond),
    };
    return dto;
  }
}
